import {filterBy} from "@progress/kendo-data-query";
import {ComboBox} from "@progress/kendo-react-dropdowns";
import React, {useEffect, useState} from "react";
import {useField, useFormikContext} from "formik";


/**
 * Please read: use the TgfFormPrimitiveComboBoxInput when you have a primitive array of data ["option 1", "option 2"]
 * if you have a complex set of data: [{id: 1, display: "option 1"}...], than use the original combobox
 **/
export const PrimitiveComboBoxInput = ({ label, required, style, disabled = false, onChange, ...otherProps }) => {
    const [field, meta] = useField(otherProps);
    const formikContext = useFormikContext();
    const { setFieldValue, values } = formikContext;
    const [data, setData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const {
        filterable = true,
        data: propData = []
    } = otherProps;

    useEffect(() => {
        setData(propData);
    }, [propData]);

    const filterData = (filter) => {
        const data = propData.slice();
        return filterBy(data, filter);
    };
    const onFilterChange = (event) => {
        setData(filterData(event.filter));
    };

    const onBlur = () => {
        setData(propData);
        setIsOpen(false);
        field.onBlur(field.name);
    };

    const onClose = () => {
        setData(propData);
        setIsOpen(false);
    };

    const onFocus = () => {
        setIsOpen(true);
    };

    const onOpen = () => {
        setIsOpen(true);
    };



    // If disabled is a function, call it with the full form context
    const isDisabled = typeof disabled === 'function'
        ? disabled({
            ...formikContext,
            fieldName: otherProps.name,
            currentValue: values[otherProps.name]
        })
        : disabled;

    const handleChange = async (e) => {
        const newValue = e.target.value;

        if (onChange) {
            // Let the custom onChange handle field updates
            await onChange(e, {
                ...formikContext,
                fieldName: otherProps.name,
                newValue,
                previousValue: values[otherProps.name]
            });
        } else {
            // Default behavior: update Formik's state
            await setFieldValue(otherProps.name, newValue);
        }
    };

    return (
        <>
            {label && (
                <label htmlFor={otherProps.id || otherProps.name}>
                    {label}
                    {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
                </label>
            )}
            <ComboBox
                onBlur={onBlur}
                onOpen={onOpen}
                onClose={onClose}
                onFocus={onFocus}
                opened={isOpen}
                onFilterChange={onFilterChange}
                value={field.value}
                filterable={filterable}
                {...otherProps}
                onChange={handleChange}
                disabled={isDisabled}
                data={data}
                label={null} // we set this to null, because label is used in the Label component up above.
            />
        </>
    );
};

